let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iii8A")).then(() => parcelRequire('lxO7G'));